import * as Sentry from '@sentry/vue'

function readReloadMarker() {
    try {
        return sessionStorage.getItem('nuxt:reload')
    } catch {
        return null
    }
}

export default defineNuxtPlugin({
    name: 'chunk-error-reload',
    setup(nuxtApp) {
        let reloading = false

        // During app init Nuxt swallows chunk load errors, so the dynamic import resolves to `undefined`
        // and the route/layout can't render. Reload instead (reloadNuxtApp's ttl prevents reload loops).
        nuxtApp.hook('app:chunkError', () => {
            if (!nuxtApp.isHydrating || reloading) {
                return
            }
            const before = readReloadMarker()
            reloadNuxtApp({ persistState: false })
            if (readReloadMarker() !== before) {
                reloading = true
                // The resulting render errors are expected and recovered by the reload; only report if it fails again.
                Sentry.addEventProcessor(() => null)
            }
        })
    },
})
